import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

export const Placeholder = ({ title, description }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow bg-gray-50 py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1
            className="text-4xl md:text-5xl font-semibold mb-6"
            style={{ color: 'var(--primary-800)' }}
          >
            {title}
          </h1>
          <p
            className="text-lg mb-8"
            style={{ color: 'var(--secondary-600)' }}
          >
            {description}
          </p>
          <div
            className="p-8 rounded-lg"
            style={{ backgroundColor: 'var(--primary-50)' }}
          >
            <p className="text-base" style={{ color: 'var(--secondary-700)' }}>
              Diese Seite befindet sich aktuell im Aufbau. Bei Fragen können Sie uns gerne
              <a
                href="/kontakt"
                className="underline font-semibold mx-1"
                style={{ color: 'var(--primary-600)' }}
              >
                kontaktieren
              </a>
              .
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Placeholder;